import CookiesJS from 'cookies-js';
import { UserFormValuesExtractor } from './userFormValuesExtractor';
import { initActivityForm } from './activity';
import { submitHandler } from '../submit-handler';
import { startBuildAfterSave } from './rebuildProgramms';
import { notify } from '../../notifications';
import { initGoalBalance } from './goalBalance';

/**
 * Карточка клиента в кабинете эксперта.
 *
 * Форма та же, что у клиента, поэтому и сбор значений общий. Разница
 * одна: сохраняем не себя, а клиента, чей идентификатор лежит на форме.
 * Что именно эксперту позволено менять, решает сервер — здесь только
 * не отправляем поля, которые в форме заблокированы.
 */
export function initClientParams($, apiClient) {
    const form = document.querySelector('form.client-form');
    if (!form) return;
    const goalBalance = initGoalBalance(form);
    initActivityForm();
    const valuesExtractor = new UserFormValuesExtractor();

    // См. personal.js: кнопка сохранения лежит в нижней панели,
    // снаружи формы, поэтому ищем её по своему классу.
    submitHandler('.action__client-params', async function () {
        const params = valuesExtractor.extractUserParams();
        // Контакты эксперт не меняет — поля выключены, и слать их незачем.
        for (const field of ['name', 'surname', 'phone']) {
            if ($(`#${field}`).prop('disabled')) delete params[field];
        }
        // Дефицит в форме в процентах, сервер хранит долей. Пустое поле
        // означает «не трогать»: настройка могла быть не задана вовсе.
        const modifier = $('#calorieModifier').val();
        if (modifier !== undefined && String(modifier).trim() !== '') {
            params.statsOverrides = { calorieModifier: parseFloat(modifier) / 100 };
        }
        // БЖУ — из ползунков раздела «Баланс». Дефицит туда не входит:
        // он про калории, баланс про БЖУ.
        const balance = document.querySelector('.macro-balance');
        if (balance && typeof balance.getBalanceOverrides === 'function') {
            const overrides = balance.getBalanceOverrides();
            if (Object.keys(overrides).length) {
                params.statsOverrides = Object.assign({}, params.statsOverrides, overrides);
            }
        }
        const goalChanged = goalBalance.prepare(params);
        await apiClient.updateUserById(
            form.getAttribute('data-client-id'),
            params,
            CookiesJS.get('auth_token'),
        );
        // В режиме автогенерации сохранение и есть запуск сборки:
        // виджет над кнопкой показывает, что программа создаётся,
        // и сам исчезает, если всё получилось.
        try {
            await startBuildAfterSave(apiClient);
        } finally {
            // Saving succeeded: redraw from authoritative server ranges even
            // if starting the program build fails or is unavailable.
            if (goalChanged) window.location.reload();
        }
    });
}
